import React, { FC } from "react";

import CampaignBuilderForm from "../../components/redesign/modules/CampaignBuilderForm";
import { CAMPAIGN_PLAY_TYPE } from "../../constants/campaignPlayTypes";
import { CAMPAIGN_STEPS } from "../../types/campaignTypes";

const ContextualMediaBuyingCreatePageRedesign: FC = () => (
  <CampaignBuilderForm
    mode="campaign"
    campaignPlayType={CAMPAIGN_PLAY_TYPE.CONTEXTUAL_MEDIA_BUYING}
    visibleOptionalPanels={[CAMPAIGN_STEPS.PUBLICATION_LISTS]}
  />
);

export default ContextualMediaBuyingCreatePageRedesign;
